import { initialGeneralState } from 'redux/initialState';
import { status } from 'constants/general';

import generalActionTypes from './action-types';

const generalReducer = (state = initialGeneralState, { type }) => {
  switch (type) {
    case generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION:
      return {
        ...state,
        registerFormSubmission: {
          status: status.FETCHING,
        },
      };

    case generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION_SUCCESS:
      return {
        ...state,
        registerFormSubmission: {
          status: status.SUCCESS,
        },
      };

    case generalActionTypes.FETCH_REGISTER_FORM_SUBMISSION_FAIL:
      return {
        ...state,
        registerFormSubmission: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default generalReducer;
